import { useGetAccessTokenPayload } from 'auth';
import { useEffect, useRef, useState } from 'react';
import { WelcomeModal } from '@/modules/auth/components/WelcomeModal.tsx';

export function WelcomePopupController() {
  const tokenPayload = useGetAccessTokenPayload();
  const checked = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (checked.current) return;
    // Attribute comes from Keycloak as string 'false' or boolean false
    const hasSeen = tokenPayload?.has_seen_welcome_sr;
    if (hasSeen === undefined || hasSeen === null) {
      return;
    }
    checked.current = true;
    if (hasSeen === false || hasSeen === 'false') {
      setOpen(true);
    }
  }, [tokenPayload?.has_seen_welcome_sr]);

  return <WelcomeModal open={open} onClose={() => setOpen(false)} />;
}
